import type { JourneyDefinition } from 'shared-components';

const journeys: readonly JourneyDefinition[] = [
  {
    name: 'webadmin.prescription_triage',
    description: 'Agent reviews an open prescription request and marks it processed',
    entryRoutes: ['Open Requests'],
    onReentry: 'ignore',
  },
];

export { journeys };
